
import { request } from "../../../config/helpers/axios-instance";
import { useQuery } from "react-query";


const fetchSalesUsers = () => {
    return useQuery(
        ["get-all-sales-users"],
        () =>
            request({
                url: `user/admin/supportUsers`,
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })

    );
}



export { fetchSalesUsers };




